import { AxiosError } from 'axios';
import useToast from './useToast';
import { ErrorType } from '../api/mutator/custom-instance';
import useLocale from '../locale/useLocale';

type ApiErrorType = string;

const useGenericErrorToast = () => {
    const { l } = useLocale();
    const showToast = useToast();
    // eslint-disable-next-line
    return (error: AxiosError<ApiErrorType> | ErrorType<any>) => {
        const errorTitle = error.response
            ? `${l('_error')}: ${error.response?.status.toString()}`
            : `${l('_error')}: ${error.code || l('_unknown')}`;
        let errorMessage: string;
        // Handle backend validation error shape
        if (
            error.response &&
            typeof error.response.data === 'object' &&
            error.response.data !== null &&
            'message' in error.response.data &&
            Array.isArray(error.response.data.errors)
        ) {
            errorMessage = [
                error.response.data.message,
                ...error.response.data.errors,
            ].join(' ');
        } else {
            errorMessage = error.response?.data || error.message;
        }
        showToast(errorTitle, errorMessage, 'error');
    };
};

export default useGenericErrorToast;
